<template>
  <div
    v-if="!appStore.treeDisplayOnlyIcon"
    @click="handleClick"
    class="group hover:border-primary mx-2 flex items-center rounded border border-transparent px-2"
    :class="[
      selectionStore.selectedMeshId === meshData.objectId ? 'bg-gray-700' : 'cursor-pointer',
      !meshData.visible && 'visible' in meshData ? 'text-gray-500' : 'text-gray-200',
    ]">
    <div
      class="flex min-w-0 flex-auto"
      :style="'padding-left:' + 2 * (depth + 1) + 'px'"
      :class="[visible ? 'opacity-100' : 'opacity-30']">
      <div class="w-4 flex-none items-center">
        <!-- No expand icon for meshes as they don't have children -->
      </div>
      <div class="flex-auto overflow-hidden">
        <div class="flex w-full items-center space-x-2">
          <div class="pi pi-cube px-1.5 text-gray-400"></div>
          <div class="truncate text-nowrap" :class="[!visible ? 'text-gray-500' : '']">
            {{ meshData.name || 'Mesh' }}
          </div>
          <div v-if="meshData.uvNames && meshData.uvNames.length > 0" class="text-xs text-gray-400">
            ({{ meshData.uvNames.length }} UV{{ meshData.uvNames.length !== 1 ? 's' : '' }})
          </div>
        </div>
      </div>
    </div>

    <div class="flex-none">
      <DButton
        text
        size="small"
        class="group-hover:text-primary w-auto p-1.5"
        :class="visible ? 'text-gray-400' : ''"
        @click="
          (event) => {
            event.stopPropagation();
            toggleMeshVisibility();
          }
        ">
        <Eye v-if="visible" size="14" :stroke-width="1.8" class="cursor-pointer text-gray-400 hover:text-gray-300" />
        <EyeOff
          v-else
          size="14"
          :stroke-width="1.8"
          @click="meshData.visible = true"
          class="cursor-pointer text-gray-500 hover:text-gray-400" />
      </DButton>
    </div>
  </div>
</template>

<script setup>
import { useSelectionStore } from '@/stores/ui/selection';
import { render } from '@/threejs/core';
import { getObjectByCode } from '@/threejs/objectManager';
import { DButton } from '@disguise/cloud-ui';
import { Eye, EyeOff } from 'lucide-vue-next';
import { ref } from 'vue';
import { useAppStore } from '../../stores/appStore';
const selectionStore = useSelectionStore();

const props = defineProps({
  meshData: {
    type: Object,
    required: true,
  },
  depth: {
    type: Number,
    default: 0,
  },
  objectId: {
    type: String,
    required: true,
  },
});

const appStore = useAppStore();

const visible = ref(true);
const handleClick = () => {
  // Set the selected mesh ID in the selection store
  selectionStore.setSelectedMesh(props.meshData.objectId, props.objectId);
};

const toggleMeshVisibility = () => {
  const modelObject = getObjectByCode(props.objectId);
  if (modelObject) {
    const meshObject = modelObject.getObjectByName(props.meshData.name);
    if (meshObject) meshObject.visible = !meshObject.visible;
    visible.value = !meshObject.visible;
    render();
  }
};
</script>
